import axios from "axios";

const baseURL =
  // process.env.VUE_APP_FILES_API_URL || "https://files-ms.whirelab.com";
  process.env.VUE_APP_API_URL || "https://files-ms.whirelab.com";

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": "*",
  },
});

export { api, baseURL };
